import { render, staticRenderFns } from "./RoundData.vue?vue&type=template&id=466450d1&scoped=true&"
import script from "./RoundData.vue?vue&type=script&lang=js&"
export * from "./RoundData.vue?vue&type=script&lang=js&"
import style0 from "./RoundData.vue?vue&type=style&index=0&id=466450d1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "466450d1",
  null
  
)

export default component.exports